import React from 'react';
import { Heart, Shield, MapPin, Star, Briefcase } from 'lucide-react';
import { useApp } from '../context/AppContext';

const ProviderCard = ({ provider }) => {
  const { favorites, toggleFavorite, setSelectedProvider, setView } = useApp();
  const p = provider;

  const handleClick = () => {
    setSelectedProvider(p);
    setView('profile');
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all overflow-hidden border border-slate-100 cursor-pointer" onClick={handleClick}>
      <div className="relative">
        <img 
          src={p.avatarUrl || `https://ui-avatars.com/api/?name=${encodeURIComponent(p.name || p.firstName + ' ' + p.lastName)}&background=0d9488&color=fff&size=300`} 
          alt={p.name} 
          className="w-full h-48 object-cover" 
          onError={e => e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(p.name || 'Provider')}&background=0d9488&color=fff`} 
        />
        <button onClick={e => { e.stopPropagation(); toggleFavorite(p.id); }} className={`absolute top-3 right-3 p-2 rounded-full ${favorites.includes(p.id) ? 'bg-red-500 text-white' : 'bg-white/90 text-slate-400'}`}>
          <Heart className={`w-5 h-5 ${favorites.includes(p.id) ? 'fill-current' : ''}`} />
        </button>
        {p.isVerified && <div className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 bg-teal-600 text-white text-xs rounded-full"><Shield className="w-3 h-3" />Verified</div>}
      </div>
      <div className="p-5">
        <div className="flex justify-between mb-2">
          <div>
            <h3 className="font-semibold text-slate-800 text-lg">{p.name || `${p.firstName} ${p.lastName}`}</h3>
            <p className="text-teal-600 text-sm">{p.providerType?.name || p.providerType}</p>
          </div>
          <div className="text-right">
            <p className="text-slate-800 font-bold">${p.hourlyRate}</p>
            <p className="text-slate-400 text-xs">/hour</p>
          </div>
        </div>
        <p className="text-slate-500 text-sm mb-3">{p.specialty}</p>
        <div className="flex gap-4 text-sm text-slate-500 mb-4">
          <span className="flex items-center gap-1"><Star className="w-4 h-4 text-amber-400 fill-amber-400" />{p.rating || p.averageRating || 0} ({p.totalReviews || 0})</span>
          <span className="flex items-center gap-1"><MapPin className="w-4 h-4" />{p.location?.city || p.city}</span>
          <span className="flex items-center gap-1"><Briefcase className="w-4 h-4" />{p.yearsOfExperience}yrs</span>
        </div>
        <div className="flex flex-wrap gap-1 mb-4">
          {(p.services || []).slice(0,3).map((s,i) => (
            <span key={i} className="px-2 py-1 bg-slate-100 text-slate-600 text-xs rounded">{typeof s === 'string' ? s : s.name}</span>
          ))}
        </div>
        <button className="w-full py-3 bg-gradient-to-r from-teal-600 to-emerald-500 text-white rounded-xl font-semibold">View Profile & Book</button>
      </div>
    </div>
  );
};

export default ProviderCard;
